import { articlePresentation } from "@/lib/articles/presentation";

export default function ArticleImageCaption({ article, as: Element = "figcaption", className = "", titleClassName = "block", creditClassName = "block" }) {
  const { imageTitle, imageCredit } = articlePresentation(article);
  if (!imageTitle && !imageCredit) return null;
  return <Element className={className}>
    {imageTitle && <span className={titleClassName} data-image-title>{imageTitle}</span>}
    {imageCredit && <span className={creditClassName} data-image-credit>{imageCredit}</span>}
  </Element>;
}
